import type {
  AndamentoProject,
  HistoricoProject,
} from "../types/timeEfficiency.types";

/** Portado 1:1 do mockup de referência (tempo-eficiencia-mmidd-v40.html),
 * #MMV-2615. Dados 100% mockados -- a migração pra dados reais da Api vem
 * depois, numa fase separada. */
export const STAGES = [
  "Orçamento",
  "BID / Em Aprovação",
  "Aprovado",
  "Realizado",
  "Pré Fechamento",
  "Liberado Operação",
  "Aguardando Cliente",
  "Faturamento",
  "Faturado",
  "Faturado/Pend. Auditoria",
  "Auditado",
];

export const STAGE_ICON: Record<string, string> = {
  Orçamento: "Or",
  "BID / Em Aprovação": "BA",
  Aprovado: "Ap",
  Realizado: "Re",
  "Pré Fechamento": "PF",
  "Liberado Operação": "LO",
  "Aguardando Cliente": "AC",
  Faturamento: "Ft",
  Faturado: "Fd",
  "Faturado/Pend. Auditoria": "PA",
  Auditado: "Au",
};

export const STAGE_COLOR = [
  "#3b6ff2",
  "#5b8def",
  "#22a06b",
  "#0ea5a0",
  "#8b5cf6",
  "#a78bfa",
  "#f2994a",
  "#eab308",
  "#64748b",
  "#c2185b",
  "#1f2937",
];

export const SIDE_ICON_COLOR = [
  "#22a06b",
  "#3b6ff2",
  "#f2994a",
  "#0ea5a0",
  "#8b5cf6",
  "#3b6ff2",
];

export const STATUS_BADGE: Record<string, { bg: string; fg: string }> = {
  "Aguardando Cliente": { bg: "#EAF0FF", fg: "#3B6FF2" },
  "Pré Fechamento": { bg: "#F3EDFF", fg: "#8B5CF6" },
  "Faturado/Pend. Auditoria": { bg: "#FEF9E6", fg: "#A1750A" },
  "BID / Em Aprovação": { bg: "#FEF1E4", fg: "#F2994A" },
  Devolvido: { bg: "#FDEAEA", fg: "#EF4444" },
  Concluído: { bg: "#E8F8F1", fg: "#22A06B" },
  Auditado: { bg: "#E8F8F1", fg: "#22A06B" },
  "Prestação de Contas": { bg: "#E8F8F1", fg: "#22A06B" },
  Cancelado: { bg: "#FDEAEA", fg: "#EF4444" },
  "Cancelado/Cobrado": { bg: "#FDEAEA", fg: "#EF4444" },
  "Cancelado/Auditado": { bg: "#FDEAEA", fg: "#EF4444" },
  "Aprovado/Cancelado": { bg: "#FDEAEA", fg: "#EF4444" },
  Duplicidade: { bg: "#FDEAEA", fg: "#EF4444" },
  Perdido: { bg: "#FDEAEA", fg: "#EF4444" },
  Declinado: { bg: "#FDEAEA", fg: "#EF4444" },
};

function subtractDaysISO(iso: string, n: number): string {
  const d = new Date(iso);
  d.setDate(d.getDate() - n);
  return d.toISOString().slice(0, 10);
}

function subtractDaysBR(br: string, n: number): string {
  const [dd, mm, yy] = br.split("/");
  const d = new Date(`${yy}-${mm}-${dd}`);
  d.setDate(d.getDate() - n);
  const p2 = (x: number) => String(x).padStart(2, "0");
  return `${p2(d.getDate())}/${p2(d.getMonth() + 1)}/${d.getFullYear()}`;
}

interface RawHistorico {
  id: string;
  celula: string;
  inicio: string;
  criacaoOffset: number;
  dur: number[];
  pend: { apos: string; dias: number } | null;
}

const RAW_HISTORICO: RawHistorico[] = [
  {
    id: "MM26101",
    celula: "Pfizer",
    inicio: "2026-08-20",
    criacaoOffset: 6,
    dur: [3, 4, 1, 2, 3, 2, 14, 3, 2, 4, 2],
    pend: { apos: "Aguardando Cliente", dias: 8 },
  },
  {
    id: "MM26088",
    celula: "Iguana A",
    inicio: "2026-08-10",
    criacaoOffset: 4,
    dur: [2, 3, 1, 2, 2, 2, 7, 2, 2, 3, 2],
    pend: null,
  },
  {
    id: "MM26075",
    celula: "Pfizer",
    inicio: "2026-07-28",
    criacaoOffset: 9,
    dur: [4, 5, 2, 2, 3, 3, 16, 4, 3, 5, 3],
    pend: { apos: "Liberado Operação", dias: 6 },
  },
  {
    id: "MM26062",
    celula: "Iguana D",
    inicio: "2026-07-15",
    criacaoOffset: 3,
    dur: [1, 2, 1, 1, 2, 1, 5, 2, 1, 3, 1],
    pend: null,
  },
  {
    id: "MM26059",
    celula: "Iguana B/Estandes",
    inicio: "2026-07-10",
    criacaoOffset: 7,
    dur: [2, 3, 1, 2, 2, 2, 9, 3, 2, 4, 2],
    pend: { apos: "Faturamento", dias: 5 },
  },
  {
    id: "MM26054",
    celula: "Iguana A",
    inicio: "2026-07-05",
    criacaoOffset: 5,
    dur: [3, 4, 1, 2, 3, 2, 8, 3, 2, 4, 2],
    pend: null,
  },
  {
    id: "MM26047",
    celula: "Pfizer",
    inicio: "2026-06-25",
    criacaoOffset: 8,
    dur: [2, 4, 1, 2, 2, 2, 18, 4, 3, 5, 3],
    pend: { apos: "Aguardando Cliente", dias: 10 },
  },
  {
    id: "MM26041",
    celula: "Iguana D",
    inicio: "2026-06-18",
    criacaoOffset: 4,
    dur: [1, 2, 1, 1, 2, 1, 6, 2, 1, 3, 1],
    pend: null,
  },
  {
    id: "MM26038",
    celula: "Iguana B/Estandes",
    inicio: "2026-06-12",
    criacaoOffset: 6,
    dur: [2, 3, 1, 2, 2, 2, 10, 3, 2, 4, 3],
    pend: { apos: "Pré Fechamento", dias: 4 },
  },
  {
    id: "MM26033",
    celula: "Iguana A",
    inicio: "2026-06-05",
    criacaoOffset: 3,
    dur: [2, 3, 1, 2, 2, 2, 7, 2, 2, 3, 2],
    pend: null,
  },
  {
    id: "MM26029",
    celula: "Pfizer",
    inicio: "2026-05-28",
    criacaoOffset: 9,
    dur: [3, 4, 1, 2, 3, 2, 12, 4, 2, 4, 2],
    pend: { apos: "Liberado Operação", dias: 5 },
  },
  {
    id: "MM26022",
    celula: "Iguana D",
    inicio: "2026-05-20",
    criacaoOffset: 2,
    dur: [1, 2, 1, 1, 1, 1, 4, 1, 1, 2, 1],
    pend: null,
  },
  {
    id: "MM26018",
    celula: "Iguana B/Estandes",
    inicio: "2026-05-14",
    criacaoOffset: 5,
    dur: [2, 3, 1, 2, 2, 2, 8, 2, 2, 3, 2],
    pend: null,
  },
  {
    id: "MM26014",
    celula: "Iguana A",
    inicio: "2026-05-08",
    criacaoOffset: 4,
    dur: [1, 2, 1, 1, 2, 1, 5, 2, 1, 3, 1],
    pend: null,
  },
  {
    id: "MM26009",
    celula: "Pfizer",
    inicio: "2026-05-02",
    criacaoOffset: 7,
    dur: [2, 3, 1, 2, 2, 2, 9, 3, 2, 4, 2],
    pend: { apos: "Faturamento", dias: 6 },
  },
  {
    id: "MM26003",
    celula: "Iguana D",
    inicio: "2026-04-25",
    criacaoOffset: 3,
    dur: [1, 2, 1, 1, 1, 1, 4, 1, 1, 2, 1],
    pend: null,
  },
];

export const HISTORICO: HistoricoProject[] = RAW_HISTORICO.map((p) => ({
  id: p.id,
  celula: p.celula,
  inicio: p.inicio,
  criacao: subtractDaysISO(p.inicio, p.criacaoOffset),
  etapas: STAGES.map((s, i) => ({ nome: s, dias: p.dur[i] })),
  pendencia: p.pend,
  total: p.dur.reduce((a, b) => a + b, 0) + (p.pend ? p.pend.dias : 0),
}));

interface RawAndamento {
  id: string;
  projeto: string;
  cliente: string;
  celula: string;
  status: string;
  entrouEm: string;
  tempoNoStatus: number;
  tempoTotal: number;
  inicio: string;
  criacaoOffset: number;
  justificativa: string;
}

const RAW_EM_ANDAMENTO: RawAndamento[] = [
  {
    id: "MM26142",
    projeto: "Congresso Nacional 2026",
    cliente: "Associação Médica Brasileira",
    celula: "Pfizer",
    status: "Aguardando Cliente",
    entrouEm: "20/08/2026",
    tempoNoStatus: 14,
    tempoTotal: 21,
    inicio: "12/08/2026",
    criacaoOffset: 6,
    justificativa: "Aguardando retorno do cliente",
  },
  {
    id: "MM26138",
    projeto: "Evento Corporativo XYZ",
    cliente: "Empresa XYZ Ltda",
    celula: "Iguana A",
    status: "Pré Fechamento",
    entrouEm: "23/08/2026",
    tempoNoStatus: 11,
    tempoTotal: 28,
    inicio: "06/08/2026",
    criacaoOffset: 9,
    justificativa: "Documentação em revisão",
  },
  {
    id: "MM26130",
    projeto: "Fórum de Inovação",
    cliente: "Tech Solutions",
    celula: "Iguana D",
    status: "Faturado/Pend. Auditoria",
    entrouEm: "24/08/2026",
    tempoNoStatus: 10,
    tempoTotal: 31,
    inicio: "04/08/2026",
    criacaoOffset: 5,
    justificativa: "Aguardando validação da auditoria",
  },
  {
    id: "MM26127",
    projeto: "Encontro de Líderes",
    cliente: "Grupo Líder",
    celula: "Iguana B/Estandes",
    status: "BID / Em Aprovação",
    entrouEm: "25/08/2026",
    tempoNoStatus: 9,
    tempoTotal: 18,
    inicio: "17/08/2026",
    criacaoOffset: 3,
    justificativa: "Em análise de aprovação",
  },
  {
    id: "MM26119",
    projeto: "Lançamento Produto X",
    cliente: "Inova Marketing",
    celula: "Iguana A",
    status: "Devolvido",
    entrouEm: "26/08/2026",
    tempoNoStatus: 8,
    tempoTotal: 24,
    inicio: "11/08/2026",
    criacaoOffset: 7,
    justificativa: "Pendência de ajuste solicitada",
  },
  {
    id: "MM26112",
    projeto: "Treinamento Anual",
    cliente: "Corp Treinamentos",
    celula: "Pfizer",
    status: "Aguardando Cliente",
    entrouEm: "27/08/2026",
    tempoNoStatus: 7,
    tempoTotal: 19,
    inicio: "16/08/2026",
    criacaoOffset: 4,
    justificativa: "Aguardando retorno do cliente",
  },
];

export const EM_ANDAMENTO: AndamentoProject[] = RAW_EM_ANDAMENTO.map((p) => ({
  ...p,
  criacao: subtractDaysBR(p.inicio, p.criacaoOffset),
}));
